import { OP } from "./actions";
import initialState from "../../../../reducers/initialState";

const OpReducer = (state = initialState, action) => {
  switch (action.type) {
    case OP.UPDATE_OPLIST: {
      return {
        ...state,
        opList: action.data,
        
      };
    }

    default:
      return state;
  }
};

export default OpReducer;
